/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const data = {
  img: "https://i.ibb.co/DrSS2fm/user.png",
  title: "Users Profile Description",
  description:
    "User management section of this application. So that the company can create a Controlled Access System to use this Application. The Authorized person can do a following operation,",
  meta: [
    {
      key: "• Invite a NEW user to operate on this Application.",
      value: "",
    },
    {
      key: "• Re-Invite the previously invited user, in case the sent invitation mail is expired Or yet Not activated.",
      value: "",
    },
    {
      key: "• De-activate a selected user to stop accessing this Application.",
      value: "",
    },
    // {
    //   key: "• Date & Time of User action",
    //   value: "",
    // },
    // {
    //   key: "• Location",
    //   value: "",
    // },
    // {
    //   key:
    //     "The Brand protection also provides user scans done on the product batches which are not on the Shelf anymore.",
    //   value: "",
    // },
  ],
  // buttons: [
  //   {
  //     key: "edit",
  //     title: "Edit",
  //   },
  // ],
};
